// extracted by mini-css-extract-plugin
export default {"container":"O_-z","productName":"P_-z","price":"Q_-z","dimensions":"R_-z"};